<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Annual Athletic Meet</h1>
    <p class="lead mb-0 text-orange-light">Celebrating Sports & Determination</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <h3 class="fw-bold text-success mb-4 text-uppercase border-bottom pb-2">
    <i class="fa-solid fa-person-running me-2"></i> Athletic Meet Gallery
  </h3>

  <div class="row g-3">
    <div class="col-6 col-md-3" *ngFor="let img of athleticImages">
      <div class="athletic-img-thumb rounded-4 overflow-hidden shadow-sm border border-2 border-white">
        <img [src]="img" alt="Athletic Track Race" class="img-fluid athletic-img">
      </div>
    </div>
  </div>
</div>
